import React from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { REQUESTED_MEETINGS_TAB, CONFIRMED_MEETINGS_TAB, SENT_MEETINGS_TAB, ALL_MEETINGS_TAB } from '../../tabs';
import styles from './TabDescription.module.scss';

const TABS_DESCRIPTIONS = {
    [REQUESTED_MEETINGS_TAB]: 'hint.tab.meetings-requests',
    [CONFIRMED_MEETINGS_TAB]: 'hint.tab.meetings-confirmed',
    [SENT_MEETINGS_TAB]: 'hint.tab.meetings-sent',
    [ALL_MEETINGS_TAB]: 'hint.tab.meetings',
};

function TabDescription(props) {
    const { meetingTab } = props,
        i18n = useI18n(),
        descriptionKey = TABS_DESCRIPTIONS[meetingTab];

    if (!descriptionKey) return null;

    return <div className={styles.TabDescription}>{i18n[descriptionKey]}</div>;
}

export default TabDescription;
